<script>
import bem from '@/utils/bem';
import styles from './to-the-top-block-style.scss';

const b = bem('to-the-top-block', styles);

export default {
  name: 'ToTheTopBlock',
  props: {
    isMobileView: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};
</script>

<template>
  <section :class="b({ isMobileView })">
    <a :class="b('link', { isMobileView })" href="#top">
      BACK TO THE TOP
    </a>
  </section>
</template>
